import { Menu } from '@edikk-edikk/icon/Menu';
import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Button, ButtonContentWithLoader, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useMenuContext, useMenuState } from '#baseMenu/hooks';

const ButtonOpen: FC = () => {
  const { open, isOpen } = useMenuContext();
  const { isActionsBlocked, isContentLoadInProcess } = useMenuState();

  if (isOpen) {
    return null;
  }

  return (
    <Button
      variant={ButtonVariant.black65}
      circle
      onClick={open}
      additionalClassName="flex-shrink-0"
      aria-label="Open menu"
      pointerEventsNone={isActionsBlocked}
    >
      <ButtonContentWithLoader
        isLoading={isContentLoadInProcess}
        content={<SvgIcon Component={Menu} width={14} height={14} />}
      />
    </Button>
  );
};

export { ButtonOpen };
